import Highcharts from 'highcharts';

import { GetColorList } from '@/core';
import { cssVarToHex } from '@/utils';
import { benchmarksMutationTypes } from '../mutation-types';

export async function getColorList({ commit }) {
  const { colorList } = await GetColorList.execute();

  Highcharts.setOptions({ colors: colorList.map(c => cssVarToHex(c.color)) });

  commit(benchmarksMutationTypes.ADD_COLOR_LIST, colorList);
}
